import { defineComponent as _defineComponent } from 'vue'
import { toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-006250b0"),n=n(),_popScopeId(),n)
const _hoisted_1 = {
  key: 0,
  class: "overflow-auto text-ellipsis"
}
const _hoisted_2 = { class: "users-table--cell-content" }


export default /*#__PURE__*/_defineComponent({
  __name: 'UsersTableCell',
  props: {
    value: null
  },
  setup(__props: any) {



return (_ctx: any,_cache: any) => {
  return (__props.value)
    ? (_openBlock(), _createElementBlock("div", _hoisted_1, [
        _createElementVNode("div", _hoisted_2, _toDisplayString(__props.value), 1)
      ]))
    : _createCommentVNode("", true)
}
}

})